module.exports = __webpack_public_path__ + "static/media/drawer-texts-on.493da024.png";